const currency = [
	{
		country: "Algeria",
		name: "Algerian Dinar",
		code: "DZD",
		locale: "en-DZ",
		language: "Arabic",
	},
	{
		country: "Angola",
		name: "Angolan Kwanza",
		code: "AOA",
		locale: "pt-AO",
		language: "Portuguese",
	},
	{
		country: "Benin",
		name: "West African CFA Franc",
		code: "XOF",
		locale: "fr-BJ",
		language: "French",
	},
	{
		country: "Botswana",
		name: "Botswana Pula",
		code: "BWP",
		locale: "en-BW",
		language: "English",
	},
	{
		country: "Burkina Faso",
		name: "West African CFA Franc",
		code: "XOF",
		locale: "fr-BF",
		language: "French",
	},
	{
		country: "Burundi",
		name: "Burundian Franc",
		code: "BIF",
		locale: "fr-BI",
		language: "French",
	},
	{
		country: "Cabo Verde",
		name: "Cape Verdean Escudo",
		code: "CVE",
		locale: "pt-CV",
		language: "Portuguese",
	},
	{
		country: "Cameroon",
		name: "Central African CFA Franc",
		code: "XAF",
		locale: "fr-CM",
		language: "French",
	},
	{
		country: "Central African Republic",
		name: "Central African CFA Franc",
		code: "XAF",
		locale: "fr-CF",
		language: "French",
	},
	{
		country: "Chad",
		name: "Central African CFA Franc",
		code: "XAF",
		locale: "fr-TD",
		language: "French",
	},
	{
		country: "Comoros",
		name: "Comorian Franc",
		code: "KMF",
		locale: "en-KM",
		language: "Arabic",
	},
	{
		country: "Congo (Brazzaville)",
		name: "Central African CFA Franc",
		code: "XAF",
		locale: "fr-CG",
		language: "French",
	},
	{
		country: "Congo (Kinshasa)",
		name: "Congolese Franc",
		code: "CDF",
		locale: "fr-CD",
		language: "French",
	},
	{
		country: "Cote d'Ivoire",
		name: "West African CFA Franc",
		code: "XOF",
		locale: "fr-CI",
		language: "French",
	},
	{
		country: "Djibouti",
		name: "Djiboutian Franc",
		code: "DJF",
		locale: "fr-DJ",
		language: "French",
	},
	{
		country: "Egypt",
		name: "Egyptian Pound",
		code: "EGP",
		locale: "ar-DZ",
		language: "Arabic",
	},
	{
		country: "Equatorial Guinea",
		name: "Central African CFA Franc",
		code: "XAF",
		locale: "es-GQ",
		language: "Spanish",
	},
	{
		country: "Eritrea",
		name: "Eritrean Nakfa",
		code: "ERN",
		locale: "ti-ER",
		language: "Tigrinya",
	},
	{
		country: "Eswatini",
		name: "Swazi Lilangeni",
		code: "SZL",
		locale: "en-SZ",
		language: "English",
	},
	{
		country: "Ethiopia",
		name: "Ethiopian Birr",
		code: "ETB",
		locale: "am-ET",
		language: "Amharic",
	},
	{
		country: "Gabon",
		name: "Central African CFA Franc",
		code: "XAF",
		locale: "fr-GA",
		language: "French",
	},
	{
		country: "Gambia",
		name: "Gambian Dalasi",
		code: "GMD",
		locale: "en-GM",
		language: "English",
	},
	{
		country: "Ghana",
		name: "Ghanaian Cedi",
		code: "GHS",
		locale: "en-GH",
		language: "English",
	},
	{
		country: "Guinea",
		name: "Guinean Franc",
		code: "GNF",
		locale: "fr-GN",
		language: "French",
	},
	{
		country: "Guinea-Bissau",
		name: "West African CFA Franc",
		code: "XOF",
		locale: "pt-GW",
		language: "Portuguese",
	},
	{
		country: "Kenya",
		name: "Kenyan Shilling",
		code: "KES",
		locale: "en-KE",
		language: "English",
	},
	{
		country: "Lesotho",
		name: "Lesotho Loti",
		code: "LSL",
		locale: "en-LS",
		language: "English",
	},
	{
		country: "Liberia",
		name: "Liberian Dollar",
		code: "LRD",
		locale: "en-LR",
		language: "English",
	},
	{
		country: "Libya",
		name: "Libyan Dinar",
		code: "LYD",
		locale: "en-LY",
		language: "Arabic",
	},
	{
		country: "Madagascar",
		name: "Malagasy Ariary",
		code: "MGA",
		locale: "mg-MG",
		language: "Malagasy",
	},
	{
		country: "Malawi",
		name: "Malawian Kwacha",
		code: "MWK",
		locale: "en-MW",
		language: "English",
	},
	{
		country: "Mali",
		name: "West African CFA Franc",
		code: "XOF",
		locale: "fr-ML",
		language: "French",
	},
	{
		country: "Mauritania",
		name: "Mauritanian Ouguiya",
		code: "MRO",
		locale: "ar-MU",
		language: "Arabic",
	},
	{
		country: "Mauritius",
		name: "Mauritian Rupee",
		code: "MUR",
		locale: "en-MU",
		language: "English",
	},
	{
		country: "Morocco",
		name: "Moroccan Dirham",
		code: "MAD",
		locale: "ar-MA",
		language: "Arabic",
	},
	{
		country: "Mozambique",
		name: "Mozambican Metical",
		code: "MZN",
		locale: "pt-MZ",
		language: "Portuguese",
	},
	{
		country: "Namibia",
		name: "Namibian Dollar",
		code: "NAD",
		locale: "en-NA",
		language: "English",
	},
	{
		country: "Niger",
		name: "West African CFA Franc",
		code: "XOF",
		locale: "fr-NE",
		language: "French",
	},
	{
		country: "Nigeria",
		name: "Nigerian Naira",
		code: "NGN",
		locale: "en-NG",
		language: "English",
	},
	{
		country: "Rwanda",
		name: "Rwandan Franc",
		code: "RWF",
		locale: "rw-RW",
		language: "Kinyarwanda",
	},
	{
		country: "Sao Tome and Principe",
		name: "Sao Tome and Principe Dobra",
		code: "STN",
		locale: "pt-ST",
		language: "Portuguese",
	},
	{
		country: "Senegal",
		name: "West African CFA Franc",
		code: "XOF",
		locale: "fr-SN",
		language: "French",
	},
	{
		country: "Seychelles",
		name: "Seychellois Rupee",
		code: "SCR",
		locale: "en-SC",
		language: "English",
	},
	{
		country: "Sierra Leone",
		name: "Sierra Leonean Leone",
		code: "SLL",
		locale: "en-SL",
		language: "English",
	},
	{
		country: "Somalia",
		name: "Somali Shilling",
		code: "SOS",
		locale: "so-SO",
		language: "Somali",
	},
	{
		country: "South Africa",
		name: "South African Rand",
		code: "ZAR",
		locale: "en-ZA",
		language: "English",
	},
	{
		country: "South Sudan",
		name: "South Sudanese Pound",
		code: "SSP",
		locale: "en-SS",
		language: "English",
	},
	{
		country: "Tanzania",
		name: "Tanzanian Shilling",
		code: "TZS",
		locale: "sw-TZ",
		language: "Swahili",
	},
	{
		country: "Togo",
		name: "West African CFA Franc",
		code: "XOF",
		locale: "fr-TG",
		language: "French",
	},
	{
		country: "Tunisia",
		name: "Tunisian Dinar",
		code: "TND",
		locale: "en-TN",
		language: "Arabic",
	},
	{
		country: "Uganda",
		name: "Ugandan Shilling",
		code: "UGX",
		locale: "en-UG",
		language: "English",
	},
	{
		country: "Zambia",
		name: "Zambian Kwacha",
		code: "ZMW",
		locale: "en-ZM",
		language: "English",
	},
	{
		country: "Zimbabwe",
		name: "Zimbabwean Dollar",
		code: "ZWL",
		locale: "en-ZW",
		language: "English",
	},
	{
		country: "Antigua and Barbuda",
		name: "East Caribbean Dollar",
		code: "XCD",
		locale: "en-AG",
		language: "English",
	},
	{
		country: "Bahamas",
		name: "Bahamian Dollar",
		code: "BSD",
		locale: "en-BS",
		language: "English",
	},
	{
		country: "Barbados",
		name: "Barbadian Dollar",
		code: "BBD",
		locale: "en-BB",
		language: "English",
	},
	{
		country: "Belize",
		name: "Belize Dollar",
		code: "BZD",
		locale: "en-BZ",
		language: "English",
	},
	{
		country: "Canada",
		name: "Canadian Dollar",
		code: "CAD",
		locale: "en-CA",
		language: "English",
	},
	{
		country: "Cuba",
		name: "Cuban Peso",
		code: "CUP",
		locale: "es-CU",
		language: "Spanish",
	},
	{
		country: "Costa Rica",
		name: "Costa Rican Colón",
		code: "CRC",
		locale: "es-CR",
		language: "Spanish",
	},
	{
		country: "Dominica",
		name: "East Caribbean Dollar",
		code: "XCD",
		locale: "en-DM",
		language: "English",
	},
	{
		country: "Dominican Republic",
		name: "Dominican Peso",
		code: "DOP",
		locale: "es-DO",
		language: "Spanish",
	},
	{
		country: "El Salvador",
		name: "Salvadoran Colón",
		code: "SVC",
		locale: "es-SV",
		language: "Spanish",
	},
	{
		country: "Grenada",
		name: "East Caribbean Dollar",
		code: "XCD",
		locale: "en-GD",
		language: "English",
	},
	{
		country: "Guatemala",
		name: "Guatemalan Quetzal",
		code: "GTQ",
		locale: "es-GT",
		language: "Spanish",
	},
	{
		country: "Haiti",
		name: "Haitian Gourde",
		code: "HTG",
		locale: "fr-HT",
		language: "French",
	},
	{
		country: "Honduras",
		name: "Honduran Lempira",
		code: "HNL",
		locale: "es-HN",
		language: "Spanish",
	},
	{
		country: "Jamaica",
		name: "Jamaican Dollar",
		code: "JMD",
		locale: "en-JM",
		language: "English",
	},
	{
		country: "Mexico",
		name: "Mexican Peso",
		code: "MXN",
		locale: "es-MX",
		language: "Spanish",
	},
	{
		country: "Nicaragua",
		name: "Nicaraguan Córdoba",
		code: "NIO",
		locale: "es-NI",
		language: "Spanish",
	},
	{
		country: "Panama",
		name: "Panamanian Balboa",
		code: "PAB",
		locale: "es-PA",
		language: "Spanish",
	},
	{
		country: "Saint Kitts and Nevis",
		name: "East Caribbean Dollar",
		code: "XCD",
		locale: "en-KN",
		language: "English",
	},
	{
		country: "Saint Lucia",
		name: "East Caribbean Dollar",
		code: "XCD",
		locale: "en-LC",
		language: "English",
	},
	{
		country: "Saint Vincent and the Grenadines",
		name: "East Caribbean Dollar",
		code: "XCD",
		locale: "en-VC",
		language: "English",
	},
	{
		country: "Trinidad and Tobago",
		name: "Trinidad and Tobago Dollar",
		code: "TTD",
		locale: "en-TT",
		language: "English",
	},
	{
		country: "United States",
		name: "United States Dollar",
		code: "USD",
		locale: "en-US",
		language: "English",
	},
	{
		country: "Argentina",
		name: "Argentine Peso",
		code: "ARS",
		locale: "es-AR",
		language: "Spanish",
	},
	{
		country: "Bolivia",
		name: "Bolivian Boliviano",
		code: "BOB",
		locale: "es-BO",
		language: "Spanish",
	},
	{
		country: "Brazil",
		name: "Brazilian Real",
		code: "BRL",
		locale: "pt-BR",
		language: "Portuguese",
	},
	{
		country: "Chile",
		name: "Chilean Peso",
		code: "CLP",
		locale: "es-CL",
		language: "Spanish",
	},
	{
		country: "Colombia",
		name: "Colombian Peso",
		code: "COP",
		locale: "es-CO",
		language: "Spanish",
	},
	{
		country: "Ecuador",
		name: "United States Dollar",
		code: "USD",
		locale: "en-US",
		language: "English",
	},
	{
		country: "Guyana",
		name: "Guyanese Dollar",
		code: "GYD",
		locale: "en-GY",
		language: "English",
	},
	{
		country: "Paraguay",
		name: "Paraguayan Guarani",
		code: "PYG",
		locale: "es-PY",
		language: "Spanish",
	},
	{
		country: "Peru",
		name: "Peruvian Sol",
		code: "PEN",
		locale: "es-PE",
		language: "Spanish",
	},
	{
		country: "Suriname",
		name: "Surinamese Dollar",
		code: "SRD",
		locale: "nl-SR",
		language: "Dutch",
	},
	{
		country: "Uruguay",
		name: "Uruguayan Peso",
		code: "UYU",
		locale: "es-UY",
		language: "Spanish",
	},
	{
		country: "Venezuela",
		name: "Venezuelan Bolívar",
		code: "VES",
		locale: "es-VE",
		language: "Spanish",
	},
	{
		country: "Albania",
		name: "Albanian Lek",
		code: "ALL",
		locale: "sq-AL",
		language: "Albanian",
	},
	{
		country: "Andorra",
		name: "Euro",
		code: "EUR",
		locale: "ca-AD",
		language: "Catalan",
	},
	{
		country: "Armenia",
		name: "Armenian Dram",
		code: "AMD",
		locale: "hy-AM",
		language: "Armenian",
	},
	{
		country: "Austria",
		name: "Euro",
		code: "EUR",
		locale: "de-AT",
		language: "German",
	},
	{
		country: "Azerbaijan",
		name: "Azerbaijani Manat",
		code: "AZN",
		locale: "az-Latn-AZ",
		language: "Azerbaijani",
	},
	{
		country: "Belarus",
		name: "Belarusian Ruble",
		code: "BYN",
		locale: "be-BY",
		language: "Belarusian",
	},
	{
		country: "Belgium",
		name: "Euro",
		code: "EUR",
		locale: "nl-BE",
		language: "Dutch",
	},
	{
		country: "Bosnia and Herzegovina",
		name: "Bosnia and Herzegovina Convertible Mark",
		code: "BAM",
		locale: "bs-BA",
		language: "Bosnian",
	},
	{
		country: "Bulgaria",
		name: "Bulgarian Lev",
		code: "BGN",
		locale: "bg-BG",
		language: "Bulgarian",
	},
	{
		country: "Croatia",
		name: "Croatian Kuna",
		code: "HRK",
		locale: "hr-HR",
		language: "Croatian",
	},
	{
		country: "Cyprus",
		name: "Euro",
		code: "EUR",
		locale: "el-CY",
		language: "Greek",
	},
	{
		country: "Czech Republic",
		name: "Czech Koruna",
		code: "CZK",
		locale: "cs-CZ",
		language: "Czech",
	},
	{
		country: "Denmark",
		name: "Danish Krone",
		code: "DKK",
		locale: "da-DK",
		language: "Danish",
	},
	{
		country: "Estonia",
		name: "Euro",
		code: "EUR",
		locale: "et-EE",
		language: "Estonian",
	},
	{
		country: "Finland",
		name: "Euro",
		code: "EUR",
		locale: "fi-FI",
		language: "Finnish",
	},
	{
		country: "France",
		name: "Euro",
		code: "EUR",
		locale: "fr-FR",
		language: "French",
	},
	{
		country: "Georgia",
		name: "Georgian Lari",
		code: "GEL",
		locale: "ka-GE",
		language: "Georgian",
	},
	{
		country: "Germany",
		name: "Euro",
		code: "EUR",
		locale: "de-DE",
		language: "German",
	},
	{
		country: "Greece",
		name: "Euro",
		code: "EUR",
		locale: "el-GR",
		language: "Greek",
	},
	{
		country: "Hungary",
		name: "Hungarian Forint",
		code: "HUF",
		locale: "hu-HU",
		language: "Hungarian",
	},
	{
		country: "Iceland",
		name: "Icelandic Króna",
		code: "ISK",
		locale: "is-IS",
		language: "Icelandic",
	},
	{
		country: "Ireland",
		name: "Euro",
		code: "EUR",
		locale: "en-IE",
		language: "English",
	},
	{
		country: "Italy",
		name: "Euro",
		code: "EUR",
		locale: "it-IT",
		language: "Italian",
	},
	{
		country: "Kazakhstan",
		name: "Kazakhstani Tenge",
		code: "KZT",
		locale: "kk-KZ",
		language: "Kazakh",
	},
	{
		country: "Kosovo",
		name: "Euro",
		code: "EUR",
		locale: "sq-XK",
		language: "Albanian",
	},
	{
		country: "Latvia",
		name: "Euro",
		code: "EUR",
		locale: "lv-LV",
		language: "Latvian",
	},
	{
		country: "Liechtenstein",
		name: "Swiss Franc",
		code: "CHF",
		locale: "de-LI",
		language: "German",
	},
	{
		country: "Lithuania",
		name: "Euro",
		code: "EUR",
		locale: "lt-LT",
		language: "Lithuanian",
	},
	{
		country: "Luxembourg",
		name: "Euro",
		code: "EUR",
		locale: "lb-LU",
		language: "Luxembourgish",
	},
	{
		country: "Malta",
		name: "Euro",
		code: "EUR",
		locale: "mt-MT",
		language: "Maltese",
	},
	{
		country: "Moldova",
		name: "Moldovan Leu",
		code: "MDL",
		locale: "ro-MD",
		language: "Romanian",
	},
	{
		country: "Monaco",
		name: "Euro",
		code: "EUR",
		locale: "fr-MC",
		language: "French",
	},
	{
		country: "Montenegro",
		name: "Euro",
		code: "EUR",
		locale: "sr-ME",
		language: "Serbian",
	},
	{
		country: "Netherlands",
		name: "Euro",
		code: "EUR",
		locale: "nl-NL",
		language: "Dutch",
	},
	{
		country: "North Macedonia",
		name: "Macedonian Denar",
		code: "MKD",
		locale: "mk-MK",
		language: "Macedonian",
	},
	{
		country: "Norway",
		name: "Norwegian Krone",
		code: "NOK",
		locale: "nb-NO",
		language: "Norwegian",
	},
	{
		country: "Poland",
		name: "Polish Złoty",
		code: "PLN",
		locale: "pl-PL",
		language: "Polish",
	},
	{
		country: "Portugal",
		name: "Euro",
		code: "EUR",
		locale: "pt-PT",
		language: "Portuguese",
	},
	{
		country: "Romania",
		name: "Romanian Leu",
		code: "RON",
		locale: "ro-RO",
		language: "Romanian",
	},
	{
		country: "Russia",
		name: "Russian Ruble",
		code: "RUB",
		locale: "ru-RU",
		language: "Russian",
	},
	{
		country: "San Marino",
		name: "Euro",
		code: "EUR",
		locale: "it-SM",
		language: "Italian",
	},
	{
		country: "Serbia",
		name: "Serbian Dinar",
		code: "RSD",
		locale: "sr-RS",
		language: "Serbian",
	},
	{
		country: "Slovakia",
		name: "Euro",
		code: "EUR",
		locale: "sk-SK",
		language: "Slovak",
	},
	{
		country: "Slovenia",
		name: "Euro",
		code: "EUR",
		locale: "sl-SI",
		language: "Slovene",
	},
	{
		country: "Spain",
		name: "Euro",
		code: "EUR",
		locale: "es-ES",
		language: "Spanish",
	},
	{
		country: "Sweden",
		name: "Swedish Krona",
		code: "SEK",
		locale: "sv-SE",
		language: "Swedish",
	},
	{
		country: "Switzerland",
		name: "Swiss Franc",
		code: "CHF",
		locale: "de-CH",
		language: "German",
	},
	{
		country: "Ukraine",
		name: "Ukrainian Hryvnia",
		code: "UAH",
		locale: "uk-UA",
		language: "Ukrainian",
	},
	{
		country: "United Kingdom",
		name: "British Pound",
		code: "GBP",
		locale: "en-GB",
		language: "English",
	},
	{
		country: "Vatican City",
		name: "Euro",
		code: "EUR",
		locale: "it-VA",
		language: "Italian",
	},
	{
		country: "Australia",
		name: "Australian Dollar",
		code: "AUD",
		locale: "en-AU",
		language: "English",
	},
	{
		country: "Fiji",
		name: "Fijian Dollar",
		code: "FJD",
		locale: "en-FJ",
		language: "English",
	},
	{
		country: "Kiribati",
		name: "Australian Dollar",
		code: "AUD",
		locale: "en-KI",
		language: "English",
	},
	{
		country: "Marshall Islands",
		name: "United States Dollar",
		code: "USD",
		locale: "en-MH",
		language: "English",
	},
	{
		country: "Micronesia",
		name: "United States Dollar",
		code: "USD",
		locale: "en-FM",
		language: "English",
	},
	{
		country: "Nauru",
		name: "Australian Dollar",
		code: "AUD",
		locale: "en-NR",
		language: "English",
	},
	{
		country: "New Zealand",
		name: "New Zealand Dollar",
		code: "NZD",
		locale: "en-NZ",
		language: "English",
	},
	{
		country: "Palau",
		name: "United States Dollar",
		code: "USD",
		locale: "en-PW",
		language: "English",
	},
	{
		country: "Papua New Guinea",
		name: "Papua New Guinean Kina",
		code: "PGK",
		locale: "en-PG",
		language: "English",
	},
	{
		country: "Samoa",
		name: "Samoan Tala",
		code: "WST",
		locale: "sm-WS",
		language: "Samoan",
	},
	{
		country: "Solomon Islands",
		name: "Solomon Islands Dollar",
		code: "SBD",
		locale: "en-SB",
		language: "English",
	},
	{
		country: "Tonga",
		name: "Tongan Paʻanga",
		code: "TOP",
		locale: "to-TO",
		language: "Tongan",
	},
	{
		country: "Tuvalu",
		name: "Australian Dollar",
		code: "AUD",
		locale: "en-TV",
		language: "English",
	},
	{
		country: "Vanuatu",
		name: "Vanuatu Vatu",
		code: "VUV",
		locale: "bi-VU",
		language: "Bislama",
	},
	{
		country: "Afghanistan",
		name: "Afghan Afghani",
		code: "AFN",
		locale: "en-AF",
		language: "Pashto",
	},
	{
		country: "Armenia",
		name: "Armenian Dram",
		code: "AMD",
		locale: "hy-AM",
		language: "Armenian",
	},
	{
		country: "Azerbaijan",
		name: "Azerbaijani Manat",
		code: "AZN",
		locale: "az-Latn-AZ",
		language: "Azerbaijani",
	},
	{
		country: "Bahrain",
		name: "Bahraini Dinar",
		code: "BHD",
		locale: "en-BH",
		language: "Arabic",
	},
	{
		country: "Bangladesh",
		name: "Bangladeshi Taka",
		code: "BDT",
		locale: "en-BD",
		language: "Bengali",
	},
	{
		country: "Bhutan",
		name: "Bhutanese Ngultrum",
		code: "BTN",
		locale: "en-BT",
		language: "Dzongkha",
	},
	{
		country: "Brunei",
		name: "Brunei Dollar",
		code: "BND",
		locale: "ms-BN",
		language: "Malay",
	},
	{
		country: "Cambodia",
		name: "Cambodian Riel",
		code: "KHR",
		locale: "km-KH",
		language: "Khmer",
	},
	{
		country: "China",
		name: "Chinese Yuan",
		code: "CNY",
		locale: "zh-CN",
		language: "Chinese",
	},
	{
		country: "Cyprus",
		name: "Euro",
		code: "EUR",
		locale: "el-CY",
		language: "Greek",
	},
	{
		country: "Georgia",
		name: "Georgian Lari",
		code: "GEL",
		locale: "ka-GE",
		language: "Georgian",
	},
	{
		country: "India",
		name: "Indian Rupee",
		code: "INR",
		locale: "hi-IN",
		language: "Hindi",
	},
	{
		country: "Indonesia",
		name: "Indonesian Rupiah",
		code: "IDR",
		locale: "id-ID",
		language: "Indonesian",
	},
	{
		country: "Iran",
		name: "Iranian Rial",
		code: "IRR",
		locale: "en-IR",
		language: "Persian",
	},
	{
		country: "Iraq",
		name: "Iraqi Dinar",
		code: "IQD",
		locale: "en-IQ",
		language: "Arabic",
	},
	{
		country: "Israel",
		name: "Israeli Shekel",
		code: "ILS",
		locale: "he-IL",
		language: "Hebrew",
	},
	{
		country: "Japan",
		name: "Japanese Yen",
		code: "JPY",
		locale: "ja-JP",
		language: "Japanese",
	},
	{
		country: "Jordan",
		name: "Jordanian Dinar",
		code: "JOD",
		locale: "en-JO",
		language: "Arabic",
	},
	{
		country: "Kazakhstan",
		name: "Kazakhstani Tenge",
		code: "KZT",
		locale: "kk-KZ",
		language: "Kazakh",
	},
	{
		country: "Kuwait",
		name: "Kuwaiti Dinar",
		code: "KWD",
		locale: "en-KW",
		language: "Arabic",
	},
	{
		country: "Kyrgyzstan",
		name: "Kyrgyzstani Som",
		code: "KGS",
		locale: "ky-KG",
		language: "Kyrgyz",
	},
	{
		country: "Laos",
		name: "Lao Kip",
		code: "LAK",
		locale: "lo-LA",
		language: "Lao",
	},
	{
		country: "Lebanon",
		name: "Lebanese Pound",
		code: "LBP",
		locale: "en-LB",
		language: "Arabic",
	},
	{
		country: "Malaysia",
		name: "Malaysian Ringgit",
		code: "MYR",
		locale: "ms-MY",
		language: "Malay",
	},
	{
		country: "Maldives",
		name: "Maldivian Rufiyaa",
		code: "MVR",
		locale: "dv-MV",
		language: "Dhivehi",
	},
	{
		country: "Mongolia",
		name: "Mongolian Tögrög",
		code: "MNT",
		locale: "mn-MN",
		language: "Mongolian",
	},
	{
		country: "Myanmar",
		name: "Burmese Kyat",
		code: "MMK",
		locale: "en-MM",
		language: "Burmese",
	},
	{
		country: "Nepal",
		name: "Nepalese Rupee",
		code: "NPR",
		locale: "ne-NP",
		language: "Nepali",
	},
	{
		country: "North Korea",
		name: "North Korean Won",
		code: "KPW",
		locale: "ko-KP",
		language: "Korean",
	},
	{
		country: "Oman",
		name: "Omani Rial",
		code: "OMR",
		locale: "en-OM",
		language: "Arabic",
	},
	{
		country: "Pakistan",
		name: "Pakistani Rupee",
		code: "PKR",
		locale: "ur-PK",
		language: "Urdu",
	},
	{
		country: "Palestine",
		name: "Israeli New Shekel",
		code: "ILS",
		locale: "en-PS",
		language: "Arabic",
	},
	{
		country: "Philippines",
		name: "Philippine Peso",
		code: "PHP",
		locale: "fil-PH",
		language: "Filipino",
	},
	{
		country: "Qatar",
		name: "Qatari Riyal",
		code: "QAR",
		locale: "en-QA",
		language: "Arabic",
	},
	{
		country: "Saudi Arabia",
		name: "Saudi Riyal",
		code: "SAR",
		locale: "en-SA",
		language: "Arabic",
	},
	{
		country: "Singapore",
		name: "Singapore Dollar",
		code: "SGD",
		locale: "zh-SG",
		language: "Chinese",
	},
	{
		country: "South Korea",
		name: "South Korean Won",
		code: "KRW",
		locale: "ko-KR",
		language: "Korean",
	},
	{
		country: "Sri Lanka",
		name: "Sri Lankan Rupee",
		code: "LKR",
		locale: "si-LK",
		language: "Sinhala",
	},
	{
		country: "Syria",
		name: "Syrian Pound",
		code: "SYP",
		locale: "en-SY",
		language: "Arabic",
	},
	{
		country: "Taiwan",
		name: "New Taiwan Dollar",
		code: "TWD",
		locale: "zh-TW",
		language: "Chinese",
	},
	{
		country: "Tajikistan",
		name: "Tajikistani Somoni",
		code: "TJS",
		locale: "tg-TJ",
		language: "Tajik",
	},
	{
		country: "Thailand",
		name: "Thai Baht",
		code: "THB",
		locale: "th-TH",
		language: "Thai",
	},
	{
		country: "Timor-Leste",
		name: "United States Dollar",
		code: "USD",
		locale: "pt-TL",
		language: "Portuguese",
	},
	{
		country: "Turkey",
		name: "Turkish Lira",
		code: "TRY",
		locale: "tr-TR",
		language: "Turkish",
	},
	{
		country: "Turkmenistan",
		name: "Turkmenistan Manat",
		code: "TMT",
		locale: "tk-TM",
		language: "Turkmen",
	},
	{
		country: "United Arab Emirates",
		name: "United Arab Emirates Dirham",
		code: "AED",
		locale: "en-AE",
		language: "Arabic",
	},
	{
		country: "Uzbekistan",
		name: "Uzbekistani Som",
		code: "UZS",
		locale: "uz-Latn-UZ",
		language: "Uzbek",
	},
	{
		country: "Vietnam",
		name: "Vietnamese Đồng",
		code: "VND",
		locale: "vi-VN",
		language: "Vietnamese",
	},
	{
		country: "Yemen",
		name: "Yemeni Rial",
		code: "YER",
		locale: "en-YE",
		language: "Arabic",
	},
];

currency.sort((a, b) => a.name.localeCompare(b.name));

const combinedFilterd = [];
const strings = [];

currency.forEach((e, i) => {
	const number = 1000;
	const modified = number.toLocaleString(e.locale, { style: "currency", currency: e.code });
	const modified2 = new Intl.NumberFormat(e.locale, { style: "currency", currency: e.code }).format(number);
	const string = `${e.name} - ${modified2}`;

	if (!strings.includes(string)) {
		e.sample = modified;
		strings.push(string);
		combinedFilterd.push(e);
	}
});

export default combinedFilterd;
